import type { FormProduct } from "@shared/types";
import { useTranslation } from "react-i18next";
import { SsProductListModal } from "./ss-product-list-modal";
import { setSsRejectedProductsModalTestId } from "./ss-rejected-products-modal.utils";

interface SsRejectedProductsModalProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onResubmit: (product: FormProduct) => void;
  readonly products: FormProduct[];
  readonly testId?: string;
}

/** Lists pre-PIM Rejected Salesforce records so an SS roaster can pick one to
 *  fix and resubmit. Thin wrapper over SsProductListModal. */
export function SsRejectedProductsModal({ open, onOpenChange, onResubmit, products, testId }: SsRejectedProductsModalProps) {
  const { t } = useTranslation();

  return (
    <SsProductListModal
      open={open}
      onOpenChange={onOpenChange}
      onAction={onResubmit}
      products={products}
      testId={testId}
      setTestId={setSsRejectedProductsModalTestId}
      rowTestIdPrefix="product"
      actionTestIdPrefix="resubmit"
      labels={{
        title: t("ssRoaster.rejectedProducts.title"),
        description: t("ssRoaster.rejectedProducts.description"),
        searchPlaceholder: t("ssRoaster.rejectedProducts.searchPlaceholder"),
        noResults: t("ssRoaster.rejectedProducts.noResults"),
        untitledProduct: t("ssRoaster.rejectedProducts.untitledProduct"),
        actionLabel: t("ssRoaster.rejectedProducts.resubmit"),
      }}
    />
  );
}
